type PostbillLocalStorage = {
  // authType is utilized to redirect user to correct login page when they try to access postbill pages on reload
  authType?: "guest" | "public" | null;
  guestToken?: string | null;
};

const STORAGE_KEY = "postbill";

function read(): PostbillLocalStorage {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
}

function write(data: PostbillLocalStorage) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function updatePostbillLocalStorage<
  K extends keyof PostbillLocalStorage,
>(key: K, value: PostbillLocalStorage[K]): void {
  const data = read();
  data[key] = value;
  write(data);
}

export function getPostbillLocalStorage<K extends keyof PostbillLocalStorage>(
  key: K
): PostbillLocalStorage[K] | undefined {
  const data = read();
  return data[key];
}
